<template>
  <b-row class="mt-4">
    <b-col cols="12" md="6">
      <questions-card
        :existingQuestions="oldQuestionsWithSameStructure"
        ref="questionCard"
        @getQuestionsList="setQuestionsList"
        class="custom-question-card"
      ></questions-card>
    </b-col>
    <b-col cols="12" md="6">
      <exam-card
        @removeQuestion="removeOldQuestion"
        :questionsList="allQuestionsTogether"
        class="custom-question-card"
      ></exam-card>
    </b-col>
    <b-col cols="12">
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="success" @click="updateQuestionsList">
          ویرایش آزمون
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    oldQuestionsList: {
      type: Array,
      required: true,
    },
  },
  emits: ["getExamQuestions", "getRemovingQuestions"],
  watch: {
    oldQuestionsList: {
      immediate: true,
      handler(val) {
        if (val) {
          val.forEach((item) => {
            if (item.questionInfo && item.questionInfo["oldQuestion"]) {
              item.questionInfo["oldQuestion"] = true;
              this.oldQuestionsWithSameStructure.push(item.questionInfo);
            }
          });
        }
      },
    },
    readyToRemoveQuestions: {
      handler(val) {
        if (val && val.length > 0) {
          this.oldQuestionsWithSameStructure =
            this.oldQuestionsWithSameStructure.filter((question) =>
              this.readyToRemoveQuestions.every(
                (removingQuestion) =>
                  removingQuestion.questionId != question.questionId
              )
            );
        }
      },
    },
  },
  data() {
    return {
      oldQuestionsWithSameStructure: [],
      questionsList: [],
      readyToRemoveQuestions: [],
    };
  },
  methods: {
    removeOldQuestion(question) {
      let removingQuestion = this.oldQuestionsList.find(
        (item) => item.questionInfo.questionId == question.questionId
      );
      if (removingQuestion) {
        this.readyToRemoveQuestions.push(removingQuestion);
      }
    },
    resetQuestions() {
      this.$refs.questionCard.resetList();
      this.questionsList = [];
      this.readyToRemoveQuestions = [];
      this.oldQuestionsList = [];
    },
    setQuestionsList(questionsList) {
      this.questionsList = questionsList;
    },
    updateQuestionsList() {
      if (
        this.readyToRemoveQuestions &&
        this.readyToRemoveQuestions.length > 0
      ) {
        this.$emit("getRemovingQuestions", this.readyToRemoveQuestions);
      }
      const examQuestions = [];
      this.questionsList.forEach((item) => {
        examQuestions.push({
          isDeleted: false,
          examQuestionId: 0,
          examId: this.$route.params.id,
          questionId: item.questionId,
          createDate: new Date(Date.now()),
          questionInfo: item,
        });
      });
      if (examQuestions.length > 0) {
        this.$emit("getExamQuestions", examQuestions);
      }
    },
  },
  computed: {
    allQuestionsTogether() {
      return [...this.oldQuestionsWithSameStructure, ...this.questionsList];
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    QuestionsCard,
    ExamCard,
  },
};
import { BRow, BCol, BButton } from "bootstrap-vue";
import QuestionsCard from "@/views/components/Exams/QuestionsCard.vue";
import ExamCard from "@/views/components/Exams/ExamCard.vue";
</script>
<style>
.custom-question-card {
  min-height: 720px;
  max-height: 720px;
  overflow-y: auto;
}
</style>
